import type { FeedItem } from "../../../types/content/feedItem";

import { isArticle } from "../../../utils/typechecks";
import { Teaser } from "../../Teaser/Teaser";

const FeedItemToTeaser = ({
  feedItem,
  positionInFeed = 0,
  currentNrOfClusters,
  isFirstFeed,
  inCluster = true,
  shouldPrioritizeImages,
}: {
  feedItem: FeedItem;
  positionInFeed: number;
  currentNrOfClusters?: number;
  isFirstFeed?: boolean;
  inCluster?: boolean;
  shouldPrioritizeImages?: boolean;
}) => {
  if (feedItem.type === "Box" || feedItem.type === "Cluster") {
    return feedItem.articles
      .filter((c) => isArticle(c))
      .map((article, articleIndex) => {
        const prioritazeImages =
          (currentNrOfClusters === 1 && isFirstFeed) ||
          (article.teaser?.image?.type === "Image" &&
            !!article.teaser?.image?.watermarks);
        return (
          <Teaser
            article={article}
            hasPriorityImage={prioritazeImages || shouldPrioritizeImages}
            articlePositionInCluster={articleIndex + 1}
            positionInFeed={positionInFeed + 1}
            key={`${article.article_id} ${positionInFeed}`}
            inCluster={inCluster}
            isBox={feedItem.type === "Box"}
            isNative={feedItem.style === "native"}
            boxName={feedItem.type === "Box" ? feedItem.name : undefined}
          />
        );
      });
  }

  if (feedItem.type === "Single") {
    const article = feedItem.article;
    const prioritazeImages =
      (currentNrOfClusters === 1 && isFirstFeed) ||
      (article.teaser?.image?.type === "Image" &&
        !!article.teaser?.image?.watermarks);

    return (
      <Teaser
        article={article}
        hasPriorityImage={prioritazeImages || shouldPrioritizeImages}
        articlePositionInCluster={1}
        positionInFeed={positionInFeed + 1}
        key={`${article.article_id} ${positionInFeed}`}
        inCluster={inCluster}
        isBox={false}
        isNative={feedItem.style === "native"}
      />
    );
  }

  return null;
};
export { FeedItemToTeaser };
